export default __webpack_public_path__ + "static/media/noImage.7bc700a9.webp";